import Vue from 'vue'
import { toRhitics } from '@rhitics/utils/links'

export default Vue.extend({
  computed: {
    isLogin(): boolean {
      return this.$auth.isLogin
    }
  },

  mounted() {
    this.checkLocale()
    this.$vuetify.theme.dark = localStorage.getItem('circadian_theme') === 'dark'
  },

  methods: {
    toHomePage() {
      location.href = '/'
    },

    toRhiticsHome() {
      toRhitics('home')
    },

    logout() {
      toRhitics('logout')
    },

    login() {
      toRhitics('login')
    },

    checkLocale() {
      if (!this.$i18n) return
      const localeRecord = localStorage.getItem('locale_preference') as string
      this.$i18n.locale = localeRecord
    }
  }
})
